/**
 * Question Sequence Configuration
 * Contains all intro, question, and hangup messages along with their subtitle timeout configurations
 */

// Intro message and subtitle timeouts
// After filtering blank lines, this has 3 lines, so we need 2 timeouts for transitions
// The final line will remain visible until audio ends (no timeout needed for final line)
export const INTRO_CONFIG = {
  text: 'Connection established.\n\nYou have reached the New Work City Laboratory.\n\nAll responses are monitored, so please speak naturally. Let\'s begin.\n\n',
  subtitleTimeouts: [1000, 2500] // Timeouts for transitions between lines (final line stays visible)
};

// Hangup message and subtitle timeouts
// After filtering blank lines, this has 4 lines, so we need 3 timeouts for transitions
// The final line will remain visible until audio ends (no timeout needed for final line)
export const HANGUP_CONFIG = {
  text: 'Experiment accepted.\n\nData recorded in the New Work City vault.\n\nYou will be contacted once results have been synthesised.\n\nThis line will now self-terminate.',
  subtitleTimeouts: [1000, 2000, 2000] // Timeouts for transitions between lines (final line stays visible)
};

// Questions configuration
export const QUESTIONS = [
  {
    id: 'question_1',
    audioFile: '/audio/questions/question_1.mp3',
    text: 'Please state your name.',
    maxDuration: 20000, // 20 seconds maximum
    subtitleTimeouts: [2000] // Timeout for single line
  },
  {
    id: 'question_2',
    audioFile: '/audio/questions/question_2.mp3',
    text: 'Confirmed.\n\nWhich organisation, movement or entity do you represent?',
    maxDuration: 20000, // 20 seconds maximum
    subtitleTimeouts: [1500] // Timeout for transition to second line (final line stays visible)
  },
  {
    id: 'question_3',
    audioFile: '/audio/questions/question_3.mp3',
    text: 'Please describe what challenge you want us to radically reimagine?',
    maxDuration: 20000, // 20 seconds maximum
    subtitleTimeouts: [2500] // Timeout for single line
  },
  {
    id: 'question_4',
    audioFile: '/audio/questions/question_4.mp3',
    text: 'Received.\n\nWe will attempt to alter this reality.\n\nWhat does success look like for you?',
    maxDuration: 20000, // 20 seconds maximum
    subtitleTimeouts: [1000, 2500] // Timeouts for transitions (final line stays visible)
  },
  {
    id: 'question_5',
    audioFile: '/audio/questions/question_5.mp3',
    text: 'Roger.\n\nPlease indicate your anticipated investment for this experiment?',
    maxDuration: 20000, // 20 seconds maximum
    subtitleTimeouts: [1000] // Timeout for transition to second line (final line stays visible)
  },
  {
    id: 'question_6',
    audioFile: '/audio/questions/question_6.mp3',
    text: 'How can we transmit your results back to you?\n\nPlease say your phone number or email address please.',
    maxDuration: 20000, // 20 seconds maximum
    subtitleTimeouts: [2500] // Timeout for transition to second line (final line stays visible)
  },
];

